import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FaHardHat } from "react-icons/fa";
import { FaComputer } from "react-icons/fa6";
import { IoSchool } from "react-icons/io5";
import { LuFileSearch2 } from "react-icons/lu";

const MyTimeline = () => {
  return (
    <VerticalTimeline
    lineColor = "rgb(216, 191, 216)">

      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ background: 'rgb(10, 10, 10)', color: '#fff', border: '2px solid rgb(30,30,30)'}}
        contentArrowStyle={{ borderRight: '7px solid  rgb(30, 30, 30)' }}
        date="Jan 2026 – Apr 2026"
        iconStyle={{ background: 'rgb(10,10,10)', color: '#fff',border:'2px solid rgb(135, 206, 235)'}}
        icon={<FaComputer />}
      >
        <h3 className="vertical-timeline-element-title">Software Engineer Intern</h3>
        <h4 className="vertical-timeline-element-subtitle">TD </h4>
        <p>
        • Incoming TD internship focused on deploying cloud-native solutions with Docker, Kubernetes, and CI/CD.
        </p>
      </VerticalTimelineElement>

      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ background: 'rgb(10, 10, 10)', color: '#fff', border: '2px solid rgb(30,30,30)'}}
        contentArrowStyle={{ borderRight: '7px solid  rgb(30, 30, 30)' }}
        date="Sep 2025 – Dec 2025"
        iconStyle={{ background: 'rgb(10,10,10)', color: '#fff',border:'2px solid rgb(135, 206, 235)'}}
        icon={<LuFileSearch2 />}
      >
        <h3 className="vertical-timeline-element-title">Data Analyst Intern</h3>
        <h4 className="vertical-timeline-element-subtitle">CIBC </h4>
        <p>
        • Improved fraud detection with a Python and PySpark pipeline processing 10MM+ monthly EFT transactions and
producing an HTML/CSS network graph to track money flow and flag potential fraud for the Fusion team.
        </p>
        <p>
        • Achieved a 40% increase in investigator efficiency by designing and developing SQL, Python, and PySpark
workflows on Azure - Databricks to filter ML alerts, cut false positives, and remove previously reviewed alerts.
        </p>
      </VerticalTimelineElement>

      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ background: 'rgb(10, 10, 10)', color: '#fff', border: '2px solid rgb(30,30,30)'}}
        contentArrowStyle={{ borderRight: '7px solid  rgb(30, 30, 30)' }}
        date="July 2025 – Present"
        iconStyle={{ background: 'rgb(10,10,10)', color: '#fff',border:'2px solid rgb(135, 206, 235)'}}
        icon={<FaComputer />}
      >
        <h3 className="vertical-timeline-element-title">Software Engineer Intern</h3>
        <h4 className="vertical-timeline-element-subtitle">Expitch · Part time internship </h4>
        <p>
        • Designing and developing a secure authentication and tokenization system using React, Node.js, and MongoDB,
integrating SSO with Auth0, API key management, and session handling.
        </p>
        <p>
        • Built a CI/CD pipeline with GitHub Actions, improving integration, testing, and delivery efficiency by 20%.
        </p>
        <p>
        • Developing a multi-agent pipeline enabling multiple LLMs to collaborate, debate, and refine responses through
advanced prompt engineering to achieve optimal results.
        </p>
      </VerticalTimelineElement>


      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ background: 'rgb(10, 10, 10)', color: '#fff', border: '2px solid rgb(30,30,30)'}}
        contentArrowStyle={{ borderRight: '7px solid  rgb(30, 30, 30)' }}
        date="May 2024 - present"
        iconStyle={{ background: 'rgb(10,10,10)', color: '#fff',border:'2px solid rgb(135, 206, 235)'}}
        icon={<LuFileSearch2 />}
      >
        <h3 className="vertical-timeline-element-title">ML/AI Research Intern</h3>
        <h4 className="vertical-timeline-element-subtitle">York University</h4>
        <p>
• Worked with prof Zhen Ming Jiang in collaboration with Huawei to develop and research production-grade ML
models and pipelines that reliably convert Android/iOS apps to the Huawei native OS apps.
        </p>
        <p>
          Designed a multi-stage RAG langchain in Python, fine-tuning LLMs with PyTorch, containerizing training on
Kubernetes for Java/Kotlin-to-ArkTS migration, evaluating UI accuracy, build integrity, and runtime stability.
 </p>
        
      </VerticalTimelineElement>



      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ background: 'rgb(10, 10, 10)', color: '#fff', border: '2px solid rgb(30,30,30)'}}
        contentArrowStyle={{ borderRight: '7px solid  rgb(30, 30, 30)' }}
        date="Sep 2023 - Apr 2024"
        iconStyle={{ background: 'rgb(10,10,10)', color: '#fff',border:'2px solid rgb(135, 206, 235)'}}
        icon={<FaComputer />}
      >
        <h3 className="vertical-timeline-element-title">Software Developer</h3>
        <h4 className="vertical-timeline-element-subtitle">York University</h4>
        <p>
        • Engineered a Python automation pipeline for Prof. Hung Viet Pham to run mutated-prompt experiments on multiple LLMs, measure code quality and coverage, and plot metrics with Matplotlib.
      </p>
        
      </VerticalTimelineElement>

      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ background: 'rgb(10, 10, 10)', color: '#fff', border: '2px solid rgb(30,30,30)'}}
        contentArrowStyle={{ borderRight: '7px solid  rgb(30, 30, 30)' }}
        date="Sep 2023 - Apr 2024"
        iconStyle={{ background: 'rgb(10,10,10)', color: '#fff',border:'2px solid rgb(135, 206, 235)'}}
        icon={<LuFileSearch2 />}
      >
        <h3 className="vertical-timeline-element-title">Data Analyst</h3>
        <h4 className="vertical-timeline-element-subtitle">York University</h4>
        <p>
        • Collaborating with Dr. Ryan K. Schott to analyze large-scale datasets of 200+ frog species using Python- PySpark and R for statistical analysis and data visualization, investigating evolutionary patterns and species assembly.
        </p>
        <p>
        • Developed automated data processing pipelines using Python, Shell, and Perl to manage and analyze 100,000+ biological entries, contributing to the identification of 150+ new species.
        </p>
      </VerticalTimelineElement>


      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ background: 'rgb(10, 10, 10)', color: '#fff', border: '2px solid rgb(30,30,30)'}}
        contentArrowStyle={{ borderRight: '7px solid  rgb(30, 30, 30)' }}
        date="Sep 2023 - Sep 2024"
        iconStyle={{ background: 'rgb(10,10,10)', color: '#fff',border:'2px solid rgb(135, 206, 235)'}}
        icon={<FaComputer />}
      >
        <h3 className="vertical-timeline-element-title">Software Engineer Intern</h3>
        <h4 className="vertical-timeline-element-subtitle">The Regional Municipality of York</h4>
        {/*<p>
        • Built a React/Django Change Request Management app in a proper SDLC process, Dockerized and deployed on EC2
with MS Oracle DB, enabling ticket submission for config/app changes and improving test efficiency.
        </p>*/}
        <p>
        • Collected and analyzed 20 system log files into a single interface by creating a Python and Flask app, centralizing log
        data and identifying specific errors, resulting in a 60% reduction in debugging time.
        </p>
        <p>
        • Developed Python and Selenium test scripts for multiple applications, boosting testing efficiency by 80% following
        developer changes, and ensuring that other interconnected applications remain unaffected by the updates.
        </p>
        <p>
        • Digitized various physical forms into IBM Maximo following a structured SDLC process, aligned with business
        upstream and downstream requirements.
        </p>
      </VerticalTimelineElement>

      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ background: 'rgb(10, 10, 10)', color: '#fff', border: '2px solid rgb(30,30,30)'}}
        contentArrowStyle={{ borderRight: '7px solid  rgb(20, 20, 20)' }}
        date="Jan 2023 – Jan 2024"
                iconStyle={{ background: 'rgb(10,10,10)', color: '#fff',border:'2px solid rgb(135, 206, 235)'}}

        icon={<FaComputer />}
      >
        <h3 className="vertical-timeline-element-title">Web Developer</h3>
        <h4 className="vertical-timeline-element-subtitle">Excel Lassonde</h4>
        <p>
        • the Excel Lassonde website, a pivotal service of the Lassonde School of Engineering designed to facilitate mentoring connections between upper-year and new students for academic support. Utilized JavaScript, HTML, and CSS to develop a robust and user-friendly platform.
        </p>
        <p>
        •  Provided and implemented a solution for students to book tutoring appointments through the website using
        Calendly, reducing 200 daily administrative tasks.
        </p>
        <p>
        • Actively collaborated with fellow team leaders and stakeholders to collect requirements and feedback, ensuring the website effectively met user needs and delivered a seamless experience.
        </p>
      </VerticalTimelineElement>

      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ background: 'rgb(10, 10, 10)', color: '#fff', border: '2px solid rgb(30,30,30)'}}
        contentArrowStyle={{ borderRight: '7px solid  rgb(20, 20, 20)' }}
        date="Sep 2021 - present"
                iconStyle={{ background: 'rgb(10,10,10)', color: '#fff',border:'2px solid rgb(135, 206, 235)'}}

        icon={<IoSchool />}
      >
        <h3 className="vertical-timeline-element-title">B.Sc., Hons. Computer Science</h3>
        <h4 className="vertical-timeline-element-subtitle">York University</h4>
        <p>
        • Maintained a high GPA throughout my academic tenure, earning the York University Continuing Student Scholarship in recognition of outstanding academic performance.
        </p>
        <p>
        • Organized and led group study sessions focused on complex mathematical problems, aiding peers in understanding and solving advanced math questions, thereby enhancing collective academic success.</p>
      </VerticalTimelineElement>

      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ background: 'rgb(10, 10, 10)', color: '#fff', border: '2px solid rgb(30,30,30)'}}
        contentArrowStyle={{ borderRight: '7px solid  rgb(20, 20, 20)' }}
        date="Nov 2019 – present"
                iconStyle={{ background: 'rgb(10,10,10)', color: '#fff',border:'2px solid rgb(135, 206, 235)'}}

        icon={<FaHardHat  />}
      >
        <h3 className="vertical-timeline-element-title">Warehouse Associate</h3>
        <h4 className="vertical-timeline-element-subtitle">YYZ1 - Amazon Fulfillment Center</h4>
        <p>
        • Adept at working through departments, including Outbound department associate, and shipping dock associate.
        </p>
        <p>
        • Able to perform troubleshooting and testing on computers, programs, machines and other work equipment with awareness of safety procedures, and the use of dangerous equipment          
        </p>
      </VerticalTimelineElement>
    </VerticalTimeline>
  );
};

export default MyTimeline;
